// The database association wins even if the author omitted or changed Task.
// An explicit manual unlink is authoritative too; never resurrect it from text.
const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i
export function bodyTask(body: string): string | null {
  const lines = body.split(/\r?\n/).filter(line => /^Task:\s*/i.test(line))
  if (lines.length !== 1) return null
  const value = lines[0].replace(/^Task:\s*/i, '').trim()
  const raw = /^jumpstart-task\s+([\da-f-]+)$/i.exec(value)?.[1]
  if (raw && UUID.test(raw)) return raw.toLowerCase()
  try {
    const url = new URL(value)
    const id = url.searchParams.get('task')
    return url.origin === 'https://hub.jumpstart.co.il' && /^\/tasks\/(table|today)$/.test(url.pathname) && id && UUID.test(id) ? id.toLowerCase() : null
  } catch { return null }
}


export type TaskLinkIdentity = {task_id:string|null;manual_override?:boolean}
export function taskLinkIdentity(body:string,link?:TaskLinkIdentity|null){
 const body_task_id=bodyTask(body),database_task_id=link?.task_id??null
 const canonical=Boolean(database_task_id||link?.manual_override)
 return {task_id:canonical?database_task_id:body_task_id,task_link_source:canonical?'database':body_task_id?'body':'none',database_task_id,body_task_id,task_link_conflict:Boolean(database_task_id&&body_task_id&&database_task_id!==body_task_id)}
}
export function prAuthoringIssues(pr:{body?:string|null;draft?:boolean},taskId:string){
 return [...(bodyTask(pr.body??'')!==taskId?['task_line_missing_or_mismatched']:[]),...(pr.draft?['draft_requires_validation_and_ready']:[])]
}
